export class CurrencyHelper {
    static formatNumberToCurrency(aValue, addUnit=false){
        if (aValue !== null){
            aValue = Number(aValue).toLocaleString('en-US');
            if(addUnit)
                aValue = `$ ${aValue}`
        }

        return aValue;
    }
}
